import axios from 'axios';
import HttpResponseCodes from './HttpResponseCodes';
import AuthUrlMap from './AuthUrlMap';

class AuthRequest {

    constructor() {
        this.messages = {
            login: {
                unauthorizedMessage: 'The provided credentials are incorrect.',
                errorMessage: 'Something went wrong. Please try again later.'
            },
        };
        this.xhrLib = axios;
    }

    config(authConfig) {
        if(authConfig.xhrLib) {
            this.xhrLib = authConfig.xhrLib;
        }
        if (authConfig.messages) {
            this.messages = authConfig.messages;
        }
    }

    async login(credentials) {
        try {
            return await this.post(AuthUrlMap.LOGIN_URL, credentials);
        } catch (e) {
            if (e.response.status === HttpResponseCodes.HTTP_UNAUTHORISED) {
                throw this.messages.login.unauthorizedMessage;
            }

            throw this.messages.login.errorMessage;
        }
    }

    async xhrAuthLink(redirectTo) {
        return await this.post(AuthUrlMap.LOGIN_XHR_URL, {
            redirectTo
        });
    }

    async xhrAuthCode(link) {
        return await this.get(link);
    }

    async loginReturn(oauthData) {
        return await this.post(AuthUrlMap.LOGIN_RETURN_URL, oauthData);
    }

    async me() {
        return await this.get(AuthUrlMap.ME_URL);
    }

    async refreshToken(refreshToken) {
        return await this.post(AuthUrlMap.REFRESH_TOKEN_URL, {
            refreshToken: refreshToken
        });
    }

    async logout() {
        return await this.post(AuthUrlMap.LOGOUT_URL);
    }

    async forgotPassword(credentials) {
        try {
            return await this.post(AuthUrlMap.FORGOT_PASSWORD_URL, credentials);
        } catch (e) {
            throw e.response;
        }
    }

    async resetPassword(credentials) {
        try {
            return await this.post(AuthUrlMap.RESET_PASSWORD_URL, credentials);
        } catch (e) {
            throw e.response;
        }
    }

    async register(params) {
        try {
            return await this.post(AuthUrlMap.REGISTER_URL, params);
        } catch (e) {
            throw e.response.data.errors;
        }
    }

    async post(url, params) {
        return await this.xhrLib.post(url, params);
    }

    async get(url, params) {
        return await this.xhrLib.get(url, params);
    }
}

export default new AuthRequest();
